export default "__VITE_ASSET__A8tZYV_Z__"